import React from 'react';

const DeleteNoModal = ({ mobileNumber, setMobileNumber, errorMessage, setErrorMessage, handleDeleteNo, setShowModal }) => (
    <div style={styles.overlay}>
        <div style={styles.box}>
            <div style={styles.header}>
                <h6 style={styles.title}>Delete Mobile Number</h6>
                <button style={styles.closeBtn} onClick={() => setShowModal(false)}>
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>
            <div style={styles.body}>
                <label style={styles.label}>Mobile Number</label>
                <input
                    type="text"
                    placeholder="Enter 10-digit mobile number"
                    value={mobileNumber}
                    maxLength="10"
                    style={{ ...styles.input, ...(errorMessage ? styles.inputError : {}) }}
                    onChange={(e) => { setMobileNumber(e.target.value); setErrorMessage(''); }}
                />
                <p style={styles.hint}>
                    <i className="bi bi-info-circle" style={{ marginRight: 5 }}></i>
                    Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9.
                </p>
                {errorMessage && <span style={styles.error}>{errorMessage}</span>}
            </div>
            <div style={styles.footer}>
                <button style={styles.btnSecondary} onClick={() => setShowModal(false)}>Cancel</button>
                <button style={styles.btnDanger} onClick={handleDeleteNo}>
                    <i className="bi bi-trash" style={{ marginRight: 6 }}></i>
                    Delete
                </button>
            </div>
        </div>
    </div>
);

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 },
    box: { background: 'white', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', overflow: 'hidden' },
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #f3f4f6', background: '#f8fafc' },
    title: { margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827' },
    closeBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: '14px', padding: 0 },
    body: { padding: '20px', display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
    input: { padding: '10px 12px', fontSize: '14px', border: '1.5px solid #d1d5db', borderRadius: '8px', outline: 'none', width: '100%', boxSizing: 'border-box', color: '#111827' },
    inputError: { borderColor: '#ef4444' },
    hint: { fontSize: '12px', color: '#9ca3af', margin: 0 },
    error: { fontSize: '12px', color: '#ef4444' },
    footer: { display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '14px 20px', borderTop: '1px solid #f3f4f6' },
    btnSecondary: { padding: '8px 16px', background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
    btnDanger: { display: 'inline-flex', alignItems: 'center', padding: '8px 16px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
};

export default DeleteNoModal;
